import React, { forwardRef, useImperativeHandle } from 'react';
import classNames from 'classnames';
import useCallbackRef from 'hooks/useCallbackRef';
import ChevrondownIcon from 'icons/Chevrondown.icon';
import { Button, Dropdown } from 'ncoded-component-library';
import { DropdownRef } from 'ncoded-component-library/build/components/molecules/Dropdown/Dropdown.component';
import { useTranslation } from 'react-i18next';

import './PortfolioDropdown.styles.scss';

type PortfolioDropdownProps = {
  className?: string;
  triggerText?: string;
  children?: JSX.Element;
};
const PortfolioDropdown: React.ForwardRefRenderFunction<
  DropdownRef,
  PortfolioDropdownProps
> = ({ className, children, triggerText }, ref) => {
  const { t } = useTranslation();
  const [dropdown, dropdownRef] = useCallbackRef<DropdownRef>();

  const classes = classNames('portfolio-dropdown-container', className);

  useImperativeHandle(ref, () => dropdown, [dropdown]);

  return (
    <div className={classes}>
      <Dropdown
        ref={dropdownRef}
        trigger={
          <Button iconPosition="right" icon={ChevrondownIcon}>
            {t(triggerText)}
          </Button>
        }
      >
        {children}
      </Dropdown>
    </div>
  );
};
export default forwardRef(PortfolioDropdown);
